import 'magnific-popup'

$(document).ready(function() {
    $('.js-gallery').each(function() {
        $(this).magnificPopup({
            tClose: '',
            delegate: 'a',
            midClick: true,
            type: 'image',
            tLoading: 'Загрузка…',
            closeBtnInside: false,
            mainClass: 'mfp-with-zoom mfp-img-mobile',
            gallery: {
                enabled: true,
                tCounter: '%curr% из %total%',
            },
            image: {
                titleSrc: 'caption',
                tError: 'Не удалось загрузить <a href="%url%" style="text-decoration: underline;">изображение</a>'
            },
            zoom: {
                enabled: true,
                duration: 300,
                opener: function(element) {
                    return element.find('img');
                }
            }
        });
    });
});



// WEBPACK FOOTER //
// ./assets/js/lightbox.js